import React, { createContext, useContext, useEffect, useState } from 'react';
import { loginCheckService } from '../services/apiService';
import { removeJwt } from '../utils';

const AppContext = createContext({ state: null, action: null });

const data = {};

export const AppProvider = ({ initValue, children }) => {
  //   const [myCards, setMyCards] = useState();
  const [profile, setProfile] = useState({ username: '' });
  //   const [profile, setProfile] = useState();
  //   const [donkiTotalSupply, setDonkiTotalSupply] = useState();

  useEffect(() => {
    loginCheckService()
      .then(data => {
        if ((data.username, data.id)) {
          setProfile(pf => ({ ...pf, username: data.username, id: data.id }));
        }
      })
      .catch(error => {
        console.log(error);
        removeJwt();
      });
  }, []);

  const value = {
    // action: { setMyCards, setMyAccount, setProfile, setDonkiTotalSupply },
    // state: { myCards, myAccount, profile, donkiTotalSupply },
    action: { setProfile },
    state: { profile },
    get: name => {
      return data[name];
    },
    set: (name, item) => {
      data[name] = item;
    },
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be use within an App Provider');
  }

  return context;
};
